

export class Sound {
    static getDefaults() {
        return {
            soundName: "",
            transpose: 0,
            start: 0,
            end: 1,
            speed: 1,
            isReverse: false,
        }
    }
}